'use client';

import { useEffect } from 'react';
import { useSession } from 'next-auth/react';

import { trackAnalyticsEvent } from '@/libs/analytics-events';

export function SignupConversionTracker() {
  const { data: session, update } = useSession();
  const signupPending = session?.user.signupPending === true;
  const signupMethod = session?.user.signupMethod ?? 'unknown';

  useEffect(() => {
    if (!signupPending) return;

    let attempts = 0;
    const interval = window.setInterval(() => {
      attempts += 1;
      if (trackAnalyticsEvent('sign_up', { method: signupMethod })) {
        void update({ signupPending: false });
        window.clearInterval(interval);
      } else if (attempts >= 20) {
        window.clearInterval(interval);
      }
    }, 500);

    return () => window.clearInterval(interval);
  }, [signupMethod, signupPending, update]);

  return null;
}
